// extracted by mini-css-extract-plugin
export default {"subtitulo":"ConfirmarFinalizarModal_subtitulo__RmTEv","lista":"ConfirmarFinalizarModal_lista__+k4ZS","texto":"ConfirmarFinalizarModal_texto__wOsAw"};